const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'LOAD_FORM_OPTIONS':
      return {
        ...state,
        sep: action.sep,
        race: action.race,
        ethnicity: action.ethnicity,
      };
    case 'CLEAR_ENROLLMENT_FORM':
      return initialState;
    default:
      return state;
  }
}
